import accountApi from '@/modules/account/api'
import { useRootStore } from '@/store/root'
import { AccountRouteName } from '@/modules/account/const'
import { isUndefined } from 'lodash'
import Vue from 'vue'

export default async function (to, from, next) {
  if (await requiresPermissionConfirmation(to)) {
    if (from.name === AccountRouteName.UsersConfirmation) {
      Vue.prototype.$notify({
        text: Vue.prototype.$pgettext('permissions_confirmation', 'Please confirm your permissions. After confirming, you can continue using internet bank services'),
        type: 'warning',
        duration: 10000
      })
    }
    return next({ name: AccountRouteName.UsersConfirmation, query: { redirectTo: to.fullPath } })
  }
  return next()
}

async function requiresPermissionConfirmation (to) {
  const rootStore = useRootStore()

  if (to.name === AccountRouteName.UsersConfirmation || isRequestedRouteUnguarded(to.path) || !rootStore.isLoggedIn) {
    return false
  }

  if (isUndefined(rootStore.isRequiredToConfirmPermissions)) {
    rootStore.isRequiredToConfirmPermissions = await accountApi.isRequiredToConfirmPermissions()
  }
  return rootStore.isRequiredToConfirmPermissions
}

function isRequestedRouteUnguarded (path) {
  const { unguardedRoutes } = window.NAVIGATION_SECURITY_CHECKS
  return unguardedRoutes.some(route => path.startsWith(route))
}
